import { types } from 'mobx-state-tree';

const FilterOption = types
  .model('FilterOption', {
    name: types.string,
    value: types.string,
    count: types.maybeNull(types.number),
  })
  .views((self) => ({
    get getCount() {
      return self.count ?? 0;
    },
  }));

export default FilterOption;
